<script setup>
const props = defineProps({
    to: { type: [String, Object], default: null },
    href: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    processing: { type: Boolean, default: false },
    target: { type: String, default: null },
    className: { type: String, default: null },
    variant: { type: String, default: "primary" },
});
</script>

<template>
    <router-link v-if="to" class="button group" :disabled :to>
        <slot />
    </router-link>
    <component
        v-else
        :is="href ? 'a' : 'button'"
        :class="[
            'body-md flex min-h-12 items-center justify-center gap-2 px-6 font-extrabold uppercase transition-colors',
            variant === 'secondary'
                ? '-secondary bg-marine-600 text-yellow-400 hover:bg-marine-500'
                : '-primary text-marine-800 bg-yellow-400 hover:bg-yellow-300',
            disabled && 'pointer-events-none opacity-50',
            className,
        ]"
        :disabled="disabled"
        :aria-disabled="disabled || null"
        :target="href ? (target ?? '_blank') : null"
        :href="disabled ? null : href"
    >
        <slot />
    </component>
</template>

<style scoped>
.-primary {
    background-image: repeating-linear-gradient(
        135deg,
        transparent 0,
        transparent 5px,
        #fccf25 5px,
        #fccf25 6px
    );
}

.-secondary {
    background-image: repeating-linear-gradient(
        135deg,
        transparent 0,
        transparent 5px,
        var(--color-marine-700) 5px,
        var(--color-marine-700) 6px
    );
}
</style>
